import { Outlet } from 'react-router-dom';
import { SidebarInset, SidebarProvider } from '@erp/ui';
import { AppSidebar } from './AppSidebar';
import { Header } from './Header';
import { Breadcrumb } from './Breadcrumb';
import { useEnsureSubdomainBound } from '@/hooks/use-ensure-subdomain-bound';
import { TrialBanner } from '@/components/billing/TrialBanner';
import { SubscriptionGate } from '@/components/billing/SubscriptionGate';
import { useCurrentTenant } from '@/hooks/use-tenant';
import {
  clearPlatformAdminTenantViewSession,
  hasActivePlatformAdminTenantViewAccess,
} from '@/lib/admin-tenant-view';
import { isPlatformAdminHost } from '@/lib/platform-admin';

export function AppLayout() {
  // Once per session, fire-and-forget re-register the tenant's subdomain
  // on Cloudflare Pages so legacy tenants (or those whose binding
  // dropped) self-heal without manual intervention. See the hook for why.
  useEnsureSubdomainBound();

  return (
    <SubscriptionGate>
      <SidebarProvider className="min-w-0 overflow-x-hidden">
        <AppSidebar />
        <SidebarInset className="min-w-0 overflow-x-hidden">
          <Header />
          <div className="min-w-0 flex-1 overflow-x-hidden overflow-y-auto p-4 md:p-6">
            <AdminTenantViewBanner />
            <TrialBanner />
            <Breadcrumb />
            <Outlet />
          </div>
        </SidebarInset>
      </SidebarProvider>
    </SubscriptionGate>
  );
}

function AdminTenantViewBanner() {
  const tenant = useCurrentTenant();
  const active = hasActivePlatformAdminTenantViewAccess();

  if (!active) return null;

  const returnToAdmin = () => {
    clearPlatformAdminTenantViewSession();
    window.location.assign(isPlatformAdminHost() ? '/' : '/platform');
  };

  return (
    <div className="mb-4 flex flex-col gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-950 shadow-sm md:flex-row md:items-center md:justify-between">
      <div className="min-w-0">
        <div className="font-semibold">Mode admin client</div>
        <div className="mt-1 text-amber-900">
          Vous consultez {tenant.data?.name ? `le tableau de bord de ${tenant.data.name}` : 'un tableau de bord client'} avec acces plateforme audite.
        </div>
      </div>
      <button
        type="button"
        onClick={returnToAdmin}
        className="inline-flex h-9 shrink-0 items-center justify-center rounded-md border border-amber-300 bg-white px-3 text-sm font-semibold text-amber-950 shadow-sm transition hover:bg-amber-100"
      >
        Retour admin
      </button>
    </div>
  );
}
